import React, { useContext, useState, useEffect } from "react";
import styles from "./BlogPostHero1.module.css";
// import stylesArabic from "./BlogPostHero1Arabic.module.css";
// import { LanguageContext } from "../../Component/LanguageContext/LanguageContext.jsx";
import { assests } from "../../assets/assests";
import { BlogsPageContent } from "../../store/BlogsPageContent";
import blogsearch from "../../assets/BlogSearch.png";
import { LanguageContext } from "../LanguageContext/LanguageContext";
import { useFilter } from "../FilterContext/FilterContext";

export default function BlogPostHero1({ searchTerm, setSearchTerm }) {
  const { blogsPageContentDetails, loading, error } =
    useContext(BlogsPageContent);
  const [showCategoryMenu, setShowCategoryMenu] = useState(false);
  const { selectedCategories, updateSelectedCategories, resetFilters } =
    useFilter();
  const [localSelectedCategories, setLocalSelectedCategories] = useState([]); // Local state for popup
  const direction = "rtl";

  // Sync local state with global state when popup opens
  useEffect(() => {
    if (showCategoryMenu) {
      setLocalSelectedCategories(selectedCategories);
    }
  }, [showCategoryMenu, selectedCategories]);

  const categoryGroups = [
    // First group - 2 elements
    [
      { id: 1, titleAr: "الكتابة" },
      { id: 2, titleAr: "الإخراج" },
    ],
    // Second group - 2 elements
    [
      { id: 3, titleAr: "التصوير والكاميرات " },
      { id: 4, titleAr: "المونتاج ومرحلة  ما بعد الإنتاج " },
    ],
    // Third group - 2 elements
    [
      { id: 5, titleAr: "الوثائقيات " },
      { id: 6, titleAr: "البرامج التلفزيونية  والأفلام" },
    ],
    // Fourth group - 2 elements
    [
      { id: 7, titleAr: "الإنتاج" },
      { id: 8, titleAr: "التمثيل " },
    ],
    // Fifth group - 2 elements
    [
      { id: 9, titleAr: "التسويق والتوزيع " },
      { id: 10, titleAr: "الفعاليات والمناسبات " },
    ],
    // Sixth group - 2 elements
    [
      { id: 11, titleAr: "تسجيل الصوت والموسيقى" },
      { id: 12, titleAr: "الذكاء الاصطناعي" },
    ],
    // Seventh group - 2 elements
    [
      { id: 13, titleAr: "المنح، المسابقات  والجوائز" },
      { id: 14, titleAr: "الوظائف والفرص " },
    ],
  ];

  if (loading) return <p>Loading...</p>; // Handle loading state
  if (error) return <p>Error loading data</p>; // Handle error state

  // Destructure blogTitle data from context
  const { blogTitle = [] } = blogsPageContentDetails || {};

  const handleCategorySelect = (titleAr) => {
    setLocalSelectedCategories((prev) => {
      if (prev.includes(titleAr)) {
        return prev.filter((cat) => cat !== titleAr);
      }
      return [...prev, titleAr];
    });
  };

  const handleApplyFilter = () => {
    updateSelectedCategories(localSelectedCategories);
    setShowCategoryMenu(false);
  };

  const handleResetFilters = () => {
    setLocalSelectedCategories([]);
    resetFilters();
    setShowCategoryMenu(false);
  };

  return (
    <div className={styles.header}>
      <div>
        <h1 style={{ fontSize: "65px" }}>
          {blogTitle[0]?.title ||
            "Read and Explore Various Articles in the Film Industry"}
        </h1>
        <div className={styles.searchBar}>
          <div className={styles.searchBox}>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className={styles.searchlogo}>
              <img src={blogsearch} alt="" />
            </span>
          </div>
          <button
            className={styles.categoryButton}
            onClick={() => setShowCategoryMenu(!showCategoryMenu)}
          >
            <span
              style={{
                position: "absolute",
                left: "30px",
                fontSize: "17px",
                fontWeight: "700",
              }}
            >
              {blogTitle[2]?.title || "Category"}
            </span>
            <img
              style={{
                position: "absolute",
                right: "30px",
                fontSize: "17px",
                fontWeight: "700",
              }}
              src={assests.filter}
              alt="Filter Icon"
            />
          </button>
          <div className={styles.categoryWrapper}>
            {showCategoryMenu && (
              <>
                <div
                  className={styles.overlay}
                  onClick={() => setShowCategoryMenu(false)}
                />
                <div className={styles.categoryMenu}>
                  <button
                    className={styles.closeButton}
                    onClick={() => setShowCategoryMenu(false)}
                  >
                    ✕
                  </button>
                  <div className={styles.menuGrid}>
                    {categoryGroups.map((group, groupIndex) => (
                      <div key={groupIndex} className={styles.menuColumn}>
                        {group.map((category) => (
                          <button
                            key={category.id}
                            className={`${styles.menuItem} ${
                              localSelectedCategories.includes(category.titleAr)
                                ? styles.selected
                                : ""
                            }`}
                            onClick={() =>
                              handleCategorySelect(category.titleAr)
                            }
                          >
                            {category.titleAr}
                          </button>
                        ))}
                      </div>
                    ))}
                  </div>
                  <div className={styles.filterActions}>
                    <button
                      className={styles.applyButton}
                      onClick={handleResetFilters}
                    >
                      تعطيل التصفية
                    </button>
                    <button
                      className={styles.applyButton}
                      onClick={handleApplyFilter}
                    >
                      تطبيق
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
